/*
 * The one control. It grows to the full width of the panel on a phone, where a founder is
 * reaching with a thumb, and sits at its natural width once there is room for the page to
 * read as a page rather than a stack of full-bleed bars.
 */
.google {
  inline-size: 100%;
}

@media (min-width: 30rem) {
  .google {
    inline-size: auto;
  }
}

.trust {
  display: grid;
  gap: var(--space-3);
}

.trustTitle {
  font-size: var(--text-lg);
}

.trustList {
  display: grid;
  gap: var(--space-2);
  padding-inline-start: var(--space-5);
  color: var(--text-muted);
  font-size: var(--text-sm);
  list-style: disc;
}
